import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import server from './../../static/json/server.json';
import './../../static/css/style.css';

import { useNavigate } from "react-router-dom";

import ReactGA from 'react-ga4';
ReactGA.initialize('G-4J51X44PYF');


function checkIfFinished(id) {
	var score = localStorage.getItem('riddle-' + id + '-score');
	return (score != null);
}

function checkIfStarted(id) {
	var guesses = localStorage.getItem('guesses-' + id);
	return (guesses != null);
}

function NewRiddleButton({lang, type}) {

	const { t } = useTranslation();
	const langBasic = (lang == "en") ? "" : lang;

	const navigate = useNavigate();
    const SERVER_ADDRESS = server["server"];
    const [url, setUrl] = useState('/#');
    const [noRiddles, setNoRiddles] = useState(false);


	useEffect(() => {
    	const fetchUrl = async () => {
        	try {
        		const response = await fetch(SERVER_ADDRESS + "/riddles", {
        	        method: "GET",
        	        headers: { 'Content-Type': 'application/json' }
        	    });
        	    const riddles = await response.json();
				const shuffle = arr => arr.sort(() => Math.random() - 0.5);
                shuffle(riddles);

				var newRiddle = "";
				var libraryId = "67d183c3a98d223dc272c7f2";

				if(!checkIfStarted(libraryId)) {
					newRiddle = libraryId;
				}

        		if(!newRiddle) {
        		    riddles.forEach((riddle) => {
			            if(!newRiddle && !checkIfStarted(riddle["id"])) {
			                newRiddle = riddle["id"];
			            }
			        });
		        }

		        if(!newRiddle) {
		            riddles.forEach((riddle) => {
			            if(!newRiddle && !checkIfFinished(riddle["id"])) {
			                newRiddle = riddle["id"];
			            }
			        });
		        }

		        if(!newRiddle) {
		            setNoRiddles(true);
		            setUrl("/" + lang + "/riddles");
		        } else {
		            setUrl("/" + lang + "/guess?id=" + newRiddle);
		        }

        	} catch (error) {

				console.log("error");
				console.log(error);
        		setUrl("/#");
            }
        }
		fetchUrl();
    }, [lang]);


    function goToNextRiddle() {
        var typeValue = "Next";
        if(type == "main") { typeValue = "Main"; }
        if(type == "different") { typeValue = "Different"; }

        ReactGA.event({
			category: 'Guesser',
		    action: 'StartRiddle',
            label: typeValue
		});
		window.location.href = url;
    }

	return (
		<>
			<Button variant="success" className="default-btn"  onClick={() => goToNextRiddle()} >
	                {
	                    type == "next" || type == "different"
	                    ? <>Next riddle</>
	                    : <>{t('play')} </>
	                }
            </Button>
		</>

	);
};

export default NewRiddleButton;
